import { initFooterNewsletter } from '@app/layout/footer-newsletter';
import { initHolidayBanner } from '@app/layout/holiday-banner';
import { initNav } from '@app/layout/nav';
import { initBanner } from '@app/layout/banner';
import { initHeader } from '@app/layout/header';
import { initAccordions } from '@app/layout/accordion';
import { initUser } from '@app/layout/user';

export const initLayout = () => {
  initNav();
  initHeader();
  initBanner();
  initHolidayBanner();
  initFooterNewsletter();
  initUser();
  initAccordions();
};
